import ApplicationsList from "../../../../../components/layout/shared/applicant/applicant_list";

export const CandidateApplicationListPage = () => {
    return (
        <>
            <ApplicationsList  />
        </>
    );
};